Ext.define('SA.lq.ModelDataFactory', {
    constructor({geoUnits, maxConditions, defaultSortTuple, conditionDeserializer}) {
        this.geoUnits = geoUnits;
        this.maxConditions = maxConditions;
        this.defaultSortTuple = defaultSortTuple;
        this.conditionDeserializer = conditionDeserializer;
    },

    create(dataParam) {
        var data = {
            ...dataParam,
            locationItem: dataParam.locationItem ?? null,
            geographicUnit: dataParam.geographicUnit ?? null,
            query: dataParam.query ?? null,
            sort: dataParam.sort ?? this.defaultSortTuple
        };

        return new SA.lq.ModelData({data, derivedState: this.getDerivedState(data)});
    },

    getDerivedState({locationItem, geographicUnit: geoUnitId, query, sort}) {
        var hasLocationItem = locationItem !== null,
            sortModel = SA.model.DataSort.fromTuple(sort),
            geoUnit = geoUnitId === null ? null : this.geoUnits.find(geoUnit => geoUnit.hasId(geoUnitId)),
            conditionList = this.conditionDeserializer.deserializeList(query),
            hasMaxConditions = conditionList.getConditionCount() === this.maxConditions,
            state = {geoUnit, conditionList, hasMaxConditions, sortModel};

        if (hasLocationItem) {
            return {
                ...state,
                isSavable: true,
                locationModel: SA.data.LocationsCache.getModel(locationItem),
                locationStringId: SA.data.LocationsCache.toLocationSeries(locationItem)
            };
        }

        return {
            ...state,
            isSavable: false,
            locationModel: null,
            locationStringId: null
        };
    }
});